// Display-only i18n for church/user denominations. The DB stores French values
// (e.g. "Message de Branham"); we map them to translation keys WITHOUT mutating
// the stored records. Unknown/custom values fall back to the raw name.
const DENOM_KEYS = {
  "Adventiste": "denom.adventiste",
  "Anglicane": "denom.anglicane",
  "Assemblées de Dieu": "denom.assemblies_god",
  "Baptiste": "denom.baptiste",
  "Catholique": "denom.catholique",
  "catholic": "denom.catholique",
  "Charismatique": "denom.charismatique",
  "Église de Dieu": "denom.church_god",
  "Évangélique": "denom.evangelique",
  "Luthérienne": "denom.lutherienne",
  "Mennonite": "denom.mennonite",
  "Message de Branham": "denom.branham",
  "Méthodiste": "denom.methodiste",
  "Non confessionnelle": "denom.non_confessionnelle",
  "Non-dénominationnelle": "denom.non_denominational",
  "Orthodoxe": "denom.orthodoxe",
  "Pentecôtiste": "denom.pentecotiste",
  "Presbytérienne": "denom.presbyterienne",
  "Protestante": "denom.protestante",
  "Quaker": "denom.quaker",
  "Réveil": "denom.reveil",
  "Salutiste": "denom.salutiste",
  "Autre": "denom.autre",
};

export const denominationLabel = (t, name) => {
  if (!name) return name || "";
  const key = DENOM_KEYS[name] || DENOM_KEYS[String(name).trim()];
  return key ? t(key, name) : name;
};

// Localized weekday names, Monday-first (church schedule stores 0=Mon..6=Sun).
export const weekdayNames = (t) => [
  t("weekday.0", "Lundi"), t("weekday.1", "Mardi"), t("weekday.2", "Mercredi"),
  t("weekday.3", "Jeudi"), t("weekday.4", "Vendredi"), t("weekday.5", "Samedi"),
  t("weekday.6", "Dimanche"),
];
